import { Injectable } from '@angular/core';
import { Md5 } from 'ts-md5/dist/md5';


@Injectable({
    providedIn: 'root'
})

export class MD5CryptoService {
    constructor() { }

    getMD5EncryptTxt = (plnTxt : string) => {
        const md5 = new Md5();
        return md5.appendStr(plnTxt).end();
    }
}